// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"41c3e8a7","760":"de1ffd35","787":"db950a91"}[chunkId] + ".chunk.js";
};